/* import __COLOCATED_TEMPLATE__ from './pause-workflows-warning.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type AiAgentSetupService from 'embercom/services/ai-agent-setup-service';

export default class PauseWorkflowsWarning extends Component {
  @service declare aiAgentSetupService: AiAgentSetupService;

  get hasLiveWorkflows() {
    return this.aiAgentSetupService.totalLiveWorkflowsCount > 0;
  }

  get hasPausedWorkflows() {
    return this.aiAgentSetupService.totalPausedWorkflowsCount > 0;
  }

  get hasAnyFinWorkflows() {
    return (
      this.aiAgentSetupService.finStats.workflowsCount.liveFinWorkflowsCount > 0 ||
      this.aiAgentSetupService.totalPausedFinWorkflowsCount > 0
    );
  }

  get numberOfWorkflows() {
    // If there are live workflows, show count of workflows that will be paused
    if (this.hasLiveWorkflows) {
      return this.aiAgentSetupService.totalLiveWorkflowsCount;
    }
    // Otherwise show count of paused workflows that will remain paused
    return this.aiAgentSetupService.totalPausedWorkflowsCount;
  }

  get translationKey() {
    // Determine if workflows will be paused or remain paused
    let willBePaused = this.hasLiveWorkflows;
    let withFin = this.hasAnyFinWorkflows;

    if (willBePaused && withFin) {
      return 'signup.teams.pricing5.annual-plans.configure-plan.features.pause-workflows.will-be-paused-with-fin';
    }
    if (willBePaused && !withFin) {
      return 'signup.teams.pricing5.annual-plans.configure-plan.features.pause-workflows.will-be-paused-without-fin';
    }
    if (!willBePaused && withFin) {
      return 'signup.teams.pricing5.annual-plans.configure-plan.features.pause-workflows.will-remain-paused-with-fin';
    }
    // !willBePaused && !withFin
    return 'signup.teams.pricing5.annual-plans.configure-plan.features.pause-workflows.will-remain-paused-without-fin';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Signup::Teams::Pricing5::Components::PauseWorkflowsWarning': typeof PauseWorkflowsWarning;
    'signup/teams/pricing5/components/pause-workflows-warning': typeof PauseWorkflowsWarning;
  }
}
